// Procedural pixel-art drawing helpers. Everything is drawn with flat rects
// (no smoothing) for a crisp retro look, with cartoon particle accents.

function rect(ctx, x, y, w, h, color) {
  ctx.fillStyle = color;
  ctx.fillRect(Math.round(x), Math.round(y), Math.round(w), Math.round(h));
}

// ---------------- Characters ----------------
export function drawCharacter(ctx, char, px, py, w, h, opts = {}) {
  const c = char.colors;
  const { frame = 0, facing = 1, state = "idle", powered = false } = opts;
  ctx.save();
  // flip around center for facing
  if (facing < 0) {
    ctx.translate(px + w, py);
    ctx.scale(-1, 1);
    px = 0;
    py = 0;
  } else {
    ctx.translate(px, py);
    px = 0;
    py = 0;
  }

  if (powered) {
    ctx.shadowColor = "#ffd400";
    ctx.shadowBlur = 18;
  }

  const u = w / 14; // unit
  const walk = state === "walk";
  const jump = state === "jump";
  const swing = walk ? Math.sin(frame * 0.4) : 0;

  // Legs
  const legY = py + 11 * (h / 18);
  const legW = 3 * u;
  const legH = 5 * (h / 18);
  if (jump) {
    rect(ctx, px + 3 * u, legY, legW, legH * 0.7, c.pants);
    rect(ctx, px + 8 * u, legY - 1, legW, legH * 0.7, c.pants);
    rect(ctx, px + 3 * u, legY + legH * 0.7 - 2, legW, 3, c.shoes);
    rect(ctx, px + 8 * u, legY + legH * 0.7 - 3, legW, 3, c.shoes);
  } else {
    rect(ctx, px + 3 * u + swing * 2, legY, legW, legH, c.pants);
    rect(ctx, px + 8 * u - swing * 2, legY, legW, legH, c.pants);
    rect(ctx, px + 3 * u + swing * 2, legY + legH - 3, legW, 3, c.shoes);
    rect(ctx, px + 8 * u - swing * 2, legY + legH - 3, legW, 3, c.shoes);
  }

  // Body / shirt
  rect(ctx, px + 2.5 * u, py + 6 * (h / 18), 9 * u, 6 * (h / 18), c.shirt);
  rect(ctx, px + 2.5 * u, py + 6 * (h / 18), 9 * u, 1.4 * (h / 18), c.shirtDark);
  // accent stripe
  rect(ctx, px + 6 * u, py + 6 * (h / 18), 2 * u, 6 * (h / 18), c.accent);

  // Arms
  const armSwing = walk ? swing * 2 : 0;
  rect(ctx, px + 1.2 * u, py + 6.5 * (h / 18) - armSwing, 1.8 * u, 4.5 * (h / 18), c.skin);
  rect(ctx, px + 11 * u, py + 6.5 * (h / 18) + armSwing, 1.8 * u, 4.5 * (h / 18), c.skin);

  // Head
  rect(ctx, px + 3.5 * u, py + 1.5 * (h / 18), 7 * u, 5 * (h / 18), c.skin);
  rect(ctx, px + 3.5 * u, py + 5 * (h / 18), 7 * u, 1 * (h / 18), c.skinDark);
  // eyes
  rect(ctx, px + 5 * u, py + 3 * (h / 18), 1.2 * u, 1.2 * (h / 18), "#1a1a1a");
  rect(ctx, px + 8 * u, py + 3 * (h / 18), 1.2 * u, 1.2 * (h / 18), "#1a1a1a");

  // Character-specific accessories
  if (char.id === "dongregorio") {
    // straw hat
    rect(ctx, px + 2 * u, py + 1.2 * (h / 18), 10 * u, 1.4 * (h / 18), c.hat);
    rect(ctx, px + 3.5 * u, py - 0.4 * (h / 18), 7 * u, 2 * (h / 18), c.hat);
    rect(ctx, px + 3.5 * u, py + 0.7 * (h / 18), 7 * u, 0.7 * (h / 18), c.hatBand);
    // mustache
    rect(ctx, px + 4.6 * u, py + 4.4 * (h / 18), 4.8 * u, 1.1 * (h / 18), "#cfcfcf");
  } else if (char.id === "jorge") {
    // cap
    rect(ctx, px + 3.2 * u, py + 0.6 * (h / 18), 7.6 * u, 1.6 * (h / 18), c.hat);
    rect(ctx, px + 8 * u, py + 1.8 * (h / 18), 4 * u, 0.9 * (h / 18), c.hat); // brim
    rect(ctx, px + 5.5 * u, py + 0.9 * (h / 18), 2 * u, 0.8 * (h / 18), c.hatBand);
  } else {
    // hair + flower
    rect(ctx, px + 2.8 * u, py + 0.6 * (h / 18), 8.4 * u, 2.2 * (h / 18), c.hair);
    rect(ctx, px + 2.4 * u, py + 2 * (h / 18), 1.4 * u, 4 * (h / 18), c.hair);
    rect(ctx, px + 10 * u, py + 2 * (h / 18), 1.4 * u, 4 * (h / 18), c.hair);
    rect(ctx, px + 9.6 * u, py + 0.2 * (h / 18), 2 * u, 2 * (h / 18), c.hatBand); // flower
    // lips
    rect(ctx, px + 6 * u, py + 4.3 * (h / 18), 2 * u, 1 * (h / 18), "#c01050");
  }

  ctx.restore();
}

// ---------------- Enemies ----------------
export function drawDog(ctx, x, y, frame, dir) {
  const w = 38, h = 26;
  ctx.save();
  if (dir < 0) {
    ctx.translate(x + w, y);
    ctx.scale(-1, 1);
    x = 0; y = 0;
  } else {
    ctx.translate(x, y);
    x = 0; y = 0;
  }
  const wag = Math.sin(frame * 0.5) * 3;
  const body = "#8a5a2c", dark = "#6b4420", light = "#a9743c";
  // legs
  rect(ctx, x + 6, y + 18, 4, 8, dark);
  rect(ctx, x + 24, y + 18, 4, 8, dark);
  rect(ctx, x + 12 + wag, y + 18, 4, 8, body);
  rect(ctx, x + 18 - wag, y + 18, 4, 8, body);
  // body
  rect(ctx, x + 4, y + 8, 26, 12, body);
  rect(ctx, x + 4, y + 8, 26, 3, light);
  // tail
  rect(ctx, x - 2, y + 6 + wag, 6, 4, body);
  // head
  rect(ctx, x + 26, y + 2, 12, 12, body);
  rect(ctx, x + 36, y + 8, 5, 4, dark); // snout
  rect(ctx, x + 30, y + 5, 2, 2, "#111"); // eye
  rect(ctx, x + 25, y - 1, 4, 5, dark); // ear
  ctx.restore();
}

export function drawAbuela(ctx, x, y, frame) {
  const w = 30, h = 50;
  const dress = "#7a3d8a", dressD = "#5e2c6c", hair = "#cfcfcf", skin = "#d8a878";
  // dress
  rect(ctx, x + 4, y + 22, 22, 28, dress);
  rect(ctx, x + 2, y + 40, 26, 10, dressD);
  // arms
  const t = Math.sin(frame * 0.2) > 0.5;
  rect(ctx, x + 0, y + 24, 5, 12, dress);
  rect(ctx, x + 25, y + (t ? 14 : 24), 5, 12, dress);
  // head
  rect(ctx, x + 7, y + 6, 16, 16, skin);
  rect(ctx, x + 5, y + 2, 20, 8, hair); // hair
  rect(ctx, x + 11, y - 2, 8, 7, hair); // bun
  rect(ctx, x + 10, y + 12, 2, 2, "#111");
  rect(ctx, x + 18, y + 12, 2, 2, "#111");
  rect(ctx, x + 11, y + 17, 8, 2, "#a05050"); // frown
  // sandal in hand when winding up
  if (t) drawChancleta(ctx, x + 28, y + 8, 0);
}

export function drawChancleta(ctx, x, y, rot) {
  ctx.save();
  ctx.translate(x + 7, y + 4);
  ctx.rotate(rot);
  rect(ctx, -8, -3, 16, 6, "#1d6fd0");
  rect(ctx, -8, -3, 16, 2, "#3a8ff0");
  rect(ctx, -2, -4, 6, 2, "#0f4f9a"); // strap
  ctx.restore();
}

// ---------------- Items ----------------
export function drawBeer(ctx, x, y, frame) {
  const bob = Math.sin(frame * 0.1) * 3;
  y += bob;
  rect(ctx, x + 4, y + 2, 8, 6, "#ffd24a"); // foam glow
  rect(ctx, x + 5, y + 6, 6, 16, "#caa23a"); // mug body
  rect(ctx, x + 5, y + 6, 6, 5, "#f6e7a0"); // foam
  rect(ctx, x + 6, y + 11, 4, 11, "#e8b93a"); // beer
  rect(ctx, x + 11, y + 9, 3, 8, "#caa23a"); // handle
  rect(ctx, x + 12, y + 10, 1, 6, "#8a6f20");
}

export function drawBottle(ctx, x, y) {
  rect(ctx, x + 2, y, 4, 4, "#caa23a"); // foam
  rect(ctx, x + 1, y + 3, 6, 12, "#3a7d2c"); // bottle
  rect(ctx, x + 2, y + 3, 2, 12, "#5aa84a");
}

export function drawDanceSpot(ctx, x, y, frame) {
  const cols = ["#ff5722", "#ffeb3b", "#0067C6", "#E91E63"];
  for (let i = 0; i < 4; i++) {
    const on = (Math.floor(frame / 12) + i) % 4;
    rect(ctx, x + (i % 2) * 22, y - 8 + Math.floor(i / 2) * 8, 22, 8, cols[on]);
  }
  // music notes float handled by particles; draw arrow marker
  ctx.fillStyle = "rgba(255,255,255,0.85)";
  ctx.font = "700 15px 'Baloo 2', system-ui, sans-serif";
  ctx.fillText("♪", x + 14, y - 18 - (Math.sin(frame * 0.1) * 4));
}

export function drawGoal(ctx, x, y, frame) {
  // Piñata on a pole
  rect(ctx, x + 14, y - 240, 6, 240, "#9a6b3a"); // pole
  const sway = Math.sin(frame * 0.08) * 6;
  const px = x + sway;
  const cols = ["#E91E63", "#FFEB3B", "#0067C6", "#4CAF50", "#FF5722"];
  for (let r = 0; r < 5; r++) {
    rect(ctx, px - 6, y - 230 + r * 12, 52, 12, cols[r % cols.length]);
  }
  rect(ctx, px + 6, y - 236, 8, 8, "#fff"); // ears
  rect(ctx, px + 26, y - 236, 8, 8, "#fff");
  ctx.fillStyle = "#fff";
  ctx.font = "700 13px 'Baloo 2', system-ui, sans-serif";
  ctx.fillText("META", px + 2, y - 250);
}
